import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogDetailComponent } from './pages/log-detail/log-detail.component';
import { LogsComponent } from './pages/logs/logs.component';
import { NotificationDetailComponent } from './pages/notification-detail/notification-detail.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { OpsOverviewComponent } from './pages/ops-overview/ops-overview.component';
import { TaskAutomationComponent } from './pages/task-automation/task-automation.component';
import { TaskDetailComponent } from './pages/task-detail/task-detail.component';
import { TeamDetailComponent } from './pages/team-detail/team-detail.component';
import { TeamComponent } from './pages/team/team.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full',
  },
  {
    path: 'overview',
    component: OpsOverviewComponent,
    data: {
      identifier: 'ops-overview',
      title: 'Operations',
    },
  },
  {
    path: 'task-rules',
    component: TaskAutomationComponent,
    data: {
      identifier: 'ops-task-rules',
    },
  },
  {
    path: 'task-rules/task/:id',
    component: TaskDetailComponent,
    data: {
      identifier: 'ops-task-rule-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'team',
    component: TeamComponent,
    data: {
      identifier: 'ops-team',
      title: 'Teammates',
    },
  },
  {
    path: 'team/member/:id',
    component: TeamDetailComponent,
    data: {
      identifier: 'ops-team-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'team/create',
    component: TeamDetailComponent,
    data: {
      identifier: 'ops-team-detail-create',
    },
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    data: {
      identifier: 'ops-notification-rules',
    },
  },
  {
    path: 'notifications/segments/:segmentuuid',
    component: NotificationsComponent,
    data: {
      identifier: 'ops-notification-rules',
      shouldReuse: false,
    },
  },
  {
    path: 'notifications/detail/:uuid',
    component: NotificationDetailComponent,
    data: {
      identifier: 'ops-notification-rule-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'log',
    component: LogsComponent,
    data: {
      identifier: 'ops-logs',
    },
  },
  {
    path: 'log/:uuid',
    component: LogDetailComponent,
    data: {
      identifier: 'ops-log-detail',
      shouldReuse: false,
    },
  },
  {
    path: 'statements',
    loadChildren: () => import('../statements/statements.module').then((m) => m.StatementsModule),
  },
  {
    path: 'my-business',
    loadChildren: () => import('../my-business/my-business.module').then((m) => m.MyBusinessModule),
  },
  {
    path: 'calendar',
    redirectTo: '/calendar',
  },
  {
    path: 'calendar/mobile',
    redirectTo: '/calendar',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OperationsRoutingModule {}
